export default __webpack_public_path__ + "static/media/CPAD_onwhite_rounded.0ffb895a.svg";